import { useContext } from 'react';

import './SalesInfoGraphPopup.scss';
import { ManualInputContext } from '../../context/context';
import { IBarData } from './IBarData';

export interface IBarsShareProps {
	barData: IBarData;
}

const SalesInfoGraphPopup = () => {
	const localContext = useContext(ManualInputContext);

	const BarsSharePartial = ({ barData }: IBarsShareProps) => {
		let percentageShare =
			localContext.graphPopupData.maxTotalSales === 0
				? 0
				: (barData.totalMarketSharePotential /
						localContext.graphPopupData.maxMarketSharePotential) *
				  100;

		return (
			<div className='sales-info-graph-popup__bar'>
				<div className='sales-info-graph-popup__bar-wrapper'>
					<div className='sales-info-graph-popup__bar-item'>
						<p className='sales-info-graph-popup__bar-text'>
							{barData.totalMarketSharePotential}
						</p>
						<div
							className='sales-info-graph-popup__bar-body share'
							style={{
								height:
									percentageShare == 0
										? '1px'
										: `${percentageShare}%`
							}}
						></div>
					</div>
				</div>

				<p className='sales-info-graph-popup__bar-quarter'>
					{barData.quarter} - {barData.year}
				</p>
			</div>
		);
	};

	const BarsSalesPartial = ({ barData }: IBarsShareProps) => {
		let percentageSales =
			localContext.graphPopupData.maxTotalSales === 0
				? 0
				: (barData.totalSales /
						localContext.graphPopupData.maxTotalSales) *
				  100;

		return (
			<div className='sales-info-graph-popup__bar'>
				<div className='sales-info-graph-popup__bar-wrapper'>
					<div className='sales-info-graph-popup__bar-item sales-info-graph-popup__bar-item--sales'>
						<p className='sales-info-graph-popup__bar-text'>
							{barData.totalSales}
						</p>
						<div
							className='sales-info-graph-popup__bar-body sales'
							style={{
								height:
									percentageSales == 0
										? '1px'
										: `${percentageSales}%`
							}}
						></div>
					</div>
				</div>

				<p className='sales-info-graph-popup__bar-quarter'>
					{barData.quarter} - {barData.year}
				</p>
			</div>
		);
	};

	return (
		<div
			className={`sales-info-graph-popup ${
				localContext.isGraphPopupShown ? 'active' : 'hidden'
			}`}
		>
			<div
				className='sales-info-graph-popup__outside'
				onClick={localContext.toggleGraphPopup}
			></div>
			<div className='sales-info-graph-popup__container'>
				<header className='sales-info-graph-popup__header'>
					<div>
						<h2 className='sales-info-graph-popup__heading'>
							Sales
						</h2>
						<p className='sales-info-graph-popup__category'>
							<strong>
								{localContext.graphPopupData.productCategory}
							</strong>
						</p>
						<p className='sales-info-graph-popup__product'>
							{localContext.graphPopupData.product}
						</p>
					</div>
					<button
						className='sales-info-graph-popup__close-btn'
						onClick={localContext.toggleGraphPopup}
						title='close'
					></button>
				</header>
				<div className='sales-info-graph-popup__bars-wrapper'>
					<BarsSharePartial
						barData={localContext.graphPopupData.bar1Data}
					/>
					<BarsSharePartial
						barData={localContext.graphPopupData.bar2Data}
					/>
					<BarsSharePartial
						barData={localContext.graphPopupData.bar3Data}
					/>
					<BarsSharePartial
						barData={localContext.graphPopupData.bar4Data}
					/>
				</div>
				<div className='sales-info-graph-popup__legend'>
					<p className='sales-info-graph-popup__legend-item'>
						Total Market Potential
					</p>
				</div>
				<div className='sales-info-graph-popup__bars-wrapper'>
					<BarsSalesPartial
						barData={localContext.graphPopupData.bar1Data}
					/>
					<BarsSalesPartial
						barData={localContext.graphPopupData.bar2Data}
					/>
					<BarsSalesPartial
						barData={localContext.graphPopupData.bar3Data}
					/>
					<BarsSalesPartial
						barData={localContext.graphPopupData.bar4Data}
					/>
				</div>
				<div className='sales-info-graph-popup__legend'>
					<p className='sales-info-graph-popup__legend-item sales-info-graph-popup__legend-item--sales'>
						Sales graph
					</p>
				</div>
			</div>
		</div>
	);
};

export default SalesInfoGraphPopup;
